import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'mage-components';

import { tPrefix as tPrefixDocumentUpload } from '../DocumentUpload/constants';
import SummaryField from '../SummaryField';

export const DocumentList = ({ documents = [] }) => (
  <>
    {documents.map(({ attachmentId, filename, type }) => (
      <Row key={attachmentId}>
        <Column>
          <SummaryField
            titleKey={`${tPrefixDocumentUpload}.explanation.${type}.title`}
            content={filename}
          />
        </Column>
      </Row>
    ))}
  </>
);

DocumentList.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      attachmentId: PropTypes.string.isRequired,
      filename: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ),
};
